import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';
import { OfflineImagePipe } from '@shared/pipes/offline-image.pipe';

@Component({
  selector: 'app-visual-event-image-viewer',
  templateUrl: './visual-event-image-viewer.component.html',
  imports: [MatIconButton, MatIcon, AsyncPipe, OfflineImagePipe],
})
export class VisualEventImageViewerComponent implements OnInit {
  public dialogRef = inject<MatDialogRef<VisualEventImageViewerComponent>>(MatDialogRef);
  public data = inject<{
    url: string;
    taskId: string;
  }>(MAT_DIALOG_DATA);

  public imageUrl: string;

  public ngOnInit() {
    this.imageUrl = this.data.url;
  }

  public close(): void {
    this.dialogRef.close();
  }
}
